import { render, staticRenderFns } from "./AustraliaConfCheckout.vue?vue&type=template&id=7f3c0972&"
import script from "./AustraliaConfCheckout.vue?vue&type=script&lang=js&"
export * from "./AustraliaConfCheckout.vue?vue&type=script&lang=js&"
import style0 from "./AustraliaConfCheckout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BCardImg, BCardTitle, BCardBody, BCard, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BCardImg, BCardTitle, BCardBody, BCard, BContainer})
    

export default component.exports